import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/service/serviceCategoryValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { ServiceCategoryContext } from "../serviceCategory";

axios.defaults.baseURL = API;

function UpdateServiceCategory(props) {

    const {dataList, setDataList, data, ServiceTypeList, setShowData} = useContext(ServiceCategoryContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.ServiceCategory.toLowerCase() === params.toLowerCase() && 
                   data.ServiceTypeID === values.ServiceTypeID
        });
        if (results.length > 0)
            handleChange("CheckServiceCategory", results[0].ServiceCategory);
        else
            handleChange("CheckServiceCategory", "");
    }

    const handleSelectServiceType = (e) => {
        var data = ServiceTypeList.filter(function (item) {
            return item.ServiceType == e.target.value
        })
        if (data.length > 0) {
            handleChange("ServiceType", data[0].ServiceType);
            handleChange("ServiceTypeID", data[0].ServiceTypeID);
        } else {
            handleChange("ServiceType", "");
            handleChange("ServiceTypeID", "");
        }
    };

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            ServiceTypeID: values.ServiceTypeID,
            ServiceCategory: values.ServiceCategory,
        }
        await axios.put(`/updateServiceCategory/${values.ServiceCategoryID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllServiceCategory();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllServiceCategory() {
        axios
          .get("/getAllServiceCategory")
          .then((response) => {
            let Data = response?.data;
            setDataList(Data);
            setShowData(Data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    const ClearData = () => {
        handleChange("ServiceTypeID", "");
        handleChange("ServiceType", "");
        handleChange("ServiceCategoryID", "");
        handleChange("ServiceCategory", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("ServiceTypeID", value.ServiceTypeID);
            handleChange("ServiceType", value.ServiceType);
            handleChange("ServiceCategoryID", value.ServiceCategoryID);
            handleChange("ServiceCategory", value.ServiceCategory);
            handleChange("CheckServiceCategory", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ແກ້ໄຂໝວດນວດ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ໜວດນວດ</span>
                                <input className={`input form-control ${errors.ServiceCategory && 'is-invalid'}`} type="text" name="ServiceCategory" onChange={(e) => handleInputStatusChange(e)} value={values.ServiceCategory || ''} required />
                                {errors.ServiceCategory && (
                                    <p className="invalid-feedback">{errors.ServiceCategory}</p>
                                )}
                            </div>
                            <div className="col form-group">
                                <label>ປະເພດນວດ: </label>
                                <select name="ServiceTypeID" onChange={(e) => handleSelectServiceType(e)}
                                    className={`input form-control ${errors.ServiceTypeID && 'is-invalid'}`}>
                                    { ServiceTypeList && ServiceTypeList.map((x, y) => {
                                        if (x.ServiceType == values.ServiceType) {
                                            return (
                                                <option key={x.ServiceTypeID} value={x.ServiceType} selected>
                                                    {x.ServiceType}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.ServiceTypeID} value={x.ServiceType}>
                                                    {x.ServiceType}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateServiceCategory;
